import React from 'react'

export interface TitleProps {
    text: string
}

export const Title = (props: TitleProps) => {
    if (!props.text) return null

    return (
        <div className="component-title-container title-spacing">
            <h1 className="component-title-container__content">{props.text}</h1>
        </div>
    )
}
